import { useMemo } from "react";

export function useToday() {
  return useMemo(() => new Date(), []);
}
